import React from "react";
import "./inc.css"
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Col, Row } from "react-bootstrap";
// ANIMATION

import ScrollAnimatiion from 'react-animate-on-scroll'

// ANIMATION

const Hfc = () =>{
    const catloglues = useSelector(state=>state.catlog)
    
    return(
        <div style={{position: "relative", minHeight: "660px"}}>
            
            <Row className="hfc_name_links">
                <Col sm={6} className="hfc_links">
                    <h4>Feature Collections</h4>
                </Col>
                <Col sm={6} className="hfc_name">
                    <Link to={"/Catalog"}>
                        <p>View All</p>
                    </Link>
                </Col>
            </Row>
            <ScrollAnimatiion animateIn='fadeInDown' 
                // animateOut='fadeOutUp'
            >
                <Row className="home-feature-collection">
                    <Col sm={6} >
                        {catloglues[19]&& <div 
                                            className="contain-hfc"
                                            style={{"background": `url(${catloglues[19]["image_links"]["front"]})`}}>
                            {/* {catloglues[12]&&<img src={catloglues[12]["image_links"]["front"]} />} */}
                            <span>
                                <h4>
                                    {catloglues[19]["name"]}
                                </h4>
                                <p>
                                    {catloglues[19]["discription"]}
                                </p>
                            </span>
                        </div>}
                        {/* hello wolrd */}
                    </Col>
                    <Col sm={6} >
                        <Row className="contain-hfc-fbc">
                            <Col sm={12}>
                                {/* female */}
                                {catloglues[16]&& <div 
                                            className="contain-hfc-fbc-body"
                                            style={{"background": `url(${catloglues[16]["image_links"]["front"]})`,
                                                    "backgroundPosition": "center",
                                                    "backgroundRepeat": "no-repeat",
                                                    "backgroundSize": "cover"}}>
                                    {/* {catloglues[12]&&<img src={catloglues[12]["image_links"]["front"]} />} */}
                                    <span>
                                        <h4>
                                            {catloglues[16]["name"]}
                                        </h4>
                                        <p>
                                            {catloglues[16]["discription"]}
                                        </p>
                                    </span>
                                </div>}
                            </Col>
                            <Col sm={6}>
                                {catloglues[83]&& <div 
                                                className="contain-hfc-fbc-body"
                                                style={{"background": `url(${catloglues[83]["image_links"]["front"]})`,
                                                        "backgroundPosition": "center",
                                                        "backgroundRepeat": "no-repeat",
                                                        "backgroundSize": "cover"}}>
                                        {/* {catloglues[12]&&<img src={catloglues[12]["image_links"]["front"]} />} */}
                                        <span>
                                            <h6>
                                                {catloglues[83]["name"]}
                                            </h6>
                                            <p>
                                                {catloglues[83]["discription"]}
                                            </p>
                                        </span>
                                </div>}
                                {/* bag */}
                            </Col>
                            
                            <Col sm={6}>
                                {/* <ScrollAnimatiion animateIn='flipInY' animateOut='flipOutY'> */}
                                {catloglues[47]&& <div 
                                                className="contain-hfc-fbc-body"
                                                style={{"background": `url(${catloglues[47]["image_links"]["front"]})`,
                                                        "backgroundPosition": "center",
                                                        "backgroundRepeat": "no-repeat",
                                                        "backgroundSize": "cover"}}>
                                        {/* {catloglues[12]&&<img src={catloglues[12]["image_links"]["front"]} />} */}
                                        <span>
                                            <h6>
                                                {catloglues[47]["name"]}
                                            </h6>
                                            <p>
                                                {catloglues[47]["discription"]}
                                            </p>
                                        </span>
                                </div>}
                                {/* cup */}
                                {/* </ScrollAnimatiion> */}
                            </Col>
                        </Row>
                        {/* hello wolrd */}
                    </Col>
                </Row>
            </ScrollAnimatiion>
            <div class="custom-shape-divider-bottom-1672831910">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M649.97 0L599.91 54.12 550.03 0 0 0 0 120 1200 120 1200 0 649.97 0z" class="shape-fill"></path>
                </svg>
            </div>
        </div>
    )
}

export default Hfc